/* eslint-disable guard-for-in,no-restricted-syntax */

import { EVENTS } from '../../../app/constants/events';

xplenty.service('connectionsService', [
  '$rootScope',
  '$stateParams',
  '$translate',
  '$resource',
  'connectionTypesService',
  function ($rootScope, $stateParams, $translate, $resource, connectionTypesService) {
    const connectionsService = {};

    connectionsService.connectionTypes = [];
    connectionsService.groups = [];

    connectionsService.connections = {
      vertica: {
        defaults: {
          tunnel_type: 'direct',
          port: 5433,
        },
      },
      azuresynapseanalytics: {
        defaults: {
          tunnel_type: 'direct',
          port: 1433,
          ssl: true,
          ssh_port: 22,
          ssh_username: 'xplenty',
        },
      },
      db2: {
        defaults: {
          tunnel_type: 'direct',
          port: 50001,
          ssl: true,
          ssh_port: 22,
          ssh_username: 'xplenty',
        },
      },
      as400: {
        defaults: {
          tunnel_type: 'direct',
          port: 50001,
          ssl: true,
          ssh_port: 22,
          ssh_username: 'xplenty',
        },
      },
      intercom: {
        auth: 'intercom',
      },
      restapi: {},
      googlecloudpostgres: {
        defaults: {
          tunnel_type: 'direct',
          port: 5432,
          ssh_port: 22,
          ssh_username: 'xplenty',
        },
      },
      googlecloudspanner: {
        auth: 'googlecloudspanner',
      },
      adwords: {
        auth: 'adwords',
      },
      analytics: {
        auth: 'analytics',
      },
      bigquery: {
        defaults: {
          region: 'gcloud::us-central1',
        },
      },
      bigqueryv2: {
        defaults: {
          region: 'gcloud::us-central1',
        },
      },
      bingads: {
        auth: 'bingads',
      },
      googlecloudsql: {
        defaults: {
          tunnel_type: 'direct',
          port: 3306,
          ssh_port: 22,
          ssh_username: 'xplenty',
        },
      },
      gs: {},
      hana: {},
      hdfs: {},
      marketingcloud: {
        defaults: {},
      },
      marketingcloudrest: {
        defaults: {},
      },
      netsuitesoap: {},
      herokupostgres: {
        defaults: {
          tunnel_type: 'direct',
          port: 5432,
          ssl: true,
          ssh_port: 22,
          ssh_username: 'xplenty',
        },
      },
      facebookadsinsights: {
        auth: 'facebookadsinsights',
      },
      mongo: {
        defaults: {
          tunnel_type: 'direct',
          port: 27017,
          ssl: false,
          read_preference: 'primary',
          ssh_port: 22,
          ssh_username: 'xplenty',
          connection_scheme: 'dns-seed-list',
        },
      },
      mysql: {
        defaults: {
          tunnel_type: 'direct',
          port: 3306,
          ssh_port: 22,
          ssh_username: 'xplenty',
        },
      },
      postgres: {
        defaults: {
          tunnel_type: 'direct',
          port: 5432,
          ssl: true,
          ssh_port: 22,
          ssh_username: 'xplenty',
        },
      },
      oracle: {
        defaults: {
          tunnel_type: 'direct',
          port: 1521,
          ssh_port: 22,
          ssh_username: 'xplenty',
        },
      },
      rackspace: {},
      redshift: {
        defaults: {
          tunnel_type: 'direct',
          port: 5439,
          ssl: true,
          region: 'amazon-web-services::us-east-1',
          ssh_port: 22,
          ssh_username: 'xplenty',
        },
      },
      s3: {
        defaults: {
          region: 'amazon-web-services::us-east-1',
        },
      },
      salesforce: {
        auth: 'salesforce',
        defaults: {
          environment: 'production',
          auth_method: 'salesforce',
        },
      },
      segment: {
        defaults: {
          tunnel_type: 'direct',
          port: 5439,
          ssl: true,
          ssh_port: 22,
          ssh_username: 'xplenty',
        },
      },
      sftp: {
        defaults: {
          auth_method: 'password',
          tunnel_type: 'direct',
          port: 22,
          ssh_port: 22,
          ssh_username: 'xplenty',
        },
      },
      ftps: {
        defaults: {
          tunnel_type: 'direct',
          port: 21,
          ssh_port: 22,
          ssh_username: 'xplenty',
        },
      },
      softlayer: {},
      sqlserver: {
        defaults: {
          tunnel_type: 'direct',
          port: 1433,
          ssl: true,
          ssh_port: 22,
          ssh_username: 'xplenty',
        },
      },
      swift: {
        defaults: {
          auth_method: 'swauth',
        },
      },
      netsuite: {
        defaults: {
          database: 'NetSuite.com',
          port: 1708,
          role_id: 0,
        },
      },
      azureblobstorage: {},
      pipedrive: {
        auth: 'pipedrive',
      },
      snowflake: {
        defaults: {
          tunnel_type: 'direct',
          region: 'snowflake::us-west-2',
          ssh_port: 22,
          ssh_username: 'xplenty',
        },
      },
      xero: {
        auth: 'xero',
      },
      linkedin: {
        auth: 'linkedin',
      },
      instagram: {
        auth: 'instagram',
      },
      googlesheets: {
        auth: 'googlesheets',
      },
      googledrive: {
        auth: 'googledrive',
      },
      youtube: {
        auth: 'youtube',
      },
      shopify: {
        auth: 'shopify',
        defaults: {
          auth_method: 'shopify',
        },
      },
      tiktokads: {
        auth: 'tiktokads',
      },
      athena: {
        defaults: {
          region: 'amazon-web-services::us-east-1',
        },
      },
    };

    connectionsService.init = function () {
      $rootScope.$log.info('Connections initiation');
      connectionTypesService.query(function (connectionTypes) {
        connectionsService.connectionTypes = connectionTypes;
        connectionsService.extendConnections();
        connectionsService.fillGroups();
        $rootScope.$broadcast(EVENTS.CONNECTION_TYPES_LOADED, connectionTypes);
      });
    };

    connectionsService.extendConnections = function () {
      _.each(connectionsService.connectionTypes, function (connectionType) {
        if (!connectionsService.connections[connectionType.type]) {
          return;
        }
        connectionsService.connections[connectionType.type].name = connectionType.name;
        connectionsService.connections[connectionType.type].description = connectionType.description;
        connectionsService.connections[connectionType.type].type = connectionType.type;
        connectionsService.connections[connectionType.type].icon_url = connectionType.icon_url;
        connectionsService.connections[connectionType.type].auth_data = {};
        connectionsService.connections[connectionType.type].button = {
          test: false,
          create: false,
          authenticate: false,
        };
      });

      connectionsService.connections.curl = {};
    };

    connectionsService.fillGroups = function () {
      const groups = {};
      const groupsArray = [];
      const extend = function (connectionType) {
        return connectionType;
      };
      _.each(connectionsService.connectionTypes, function (connectionType) {
        _.each(connectionType.groups, function (group) {
          if (groups[group.group_type]) {
            groups[group.group_type].connections.push(extend(connectionType));
          } else {
            groups[group.group_type] = {
              name: group.group_name,
              connections: [extend(connectionType)],
            };
          }
        });
      });
      for (const groupId in groups) {
        groupsArray.push(groups[groupId]);
      }
      connectionsService.groups = groupsArray;
    };

    return connectionsService;
  },
]);
